// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsCameraBackCamera_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.42 16.585L16.79 14.2031L18.21 15.6186L16.83 16.9999L20.5 17.0006C22.433 17.0006 24 18.5677 24 20.5007C24 22.4337 22.433 24.0007 20.5 24.0007L19.2329 24.0007V22.0007L20.5 22.0007C21.3284 22.0007 22 21.3292 22 20.5007C22 19.6723 21.3284 19.0007 20.5 19.0007V19.0034H16.83L18.21 20.3853L16.79 21.8007L14.42 19.4183L13 18.0017L14.42 16.585Z" class="svg-bg"/>
  <path d="M14.42 16.585 16.79 14.2031 18.21 15.6186 16.83 16.9999 20.5 17.0006C22.433 17.0006 24 18.5677 24 20.5007 24 22.4337 22.433 24.0007 20.5 24.0007L19.2329 24.0007V22.0007L20.5 22.0007C21.3284 22.0007 22 21.3292 22 20.5007 22 19.6723 21.3284 19.0007 20.5 19.0007V19.0034H16.83L18.21 20.3853 16.79 21.8007 14.42 19.4183 13 18.0017 14.42 16.585ZM6 0H16L17 2H5L6 0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 16C13.2091 16 15 14.2091 15 12C15 9.79086 13.2091 8 11 8C8.79086 8 7 9.79086 7 12C7 14.2091 8.79086 16 11 16ZM11 14C12.1046 14 13 13.1046 13 12C13 10.8954 12.1046 10 11 10C9.89543 10 9 10.8954 9 12C9 13.1046 9.89543 14 11 14Z" class="svg-bg"/>
  <path d="M0 4H22V15H20V6H2V18H10.1758L12.1758 20H0V4Z" class="svg-bg"/>
  <path d="M16 18.0471V18H15.9286L16 18.0471Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsCameraBackCamera is a generated icon component.
 */
let IconRmsCameraBackCamera = IconRmsCameraBackCamera_1 = class IconRmsCameraBackCamera extends IconBaseElement {
    render() {
        return html `${IconRmsCameraBackCamera_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsCameraBackCamera.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsCameraBackCamera = IconRmsCameraBackCamera_1 = __decorate([
    customElement('zui-icon-rms-camera-back-camera')
], IconRmsCameraBackCamera);
export { IconRmsCameraBackCamera };
